module.exports = "/img/_/_/_/assets/images/creeper/book/rare//12.jpg?b5d462b62367eefe0a53ecbdb2a07693";